const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'wishlistactive';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-list-item',
  wishlistCount: '.wishlistCount',
};

document.addEventListener('DOMContentLoaded', () => {  
   const wishlist = getWishlist(); 
const wishlistCountElement = document.querySelector(selectors.wishlistCount);
if (wishlistCountElement) {
  wishlistCountElement.textContent = wishlist.length;
}

  toggleWishlistBubbleVisibility();
  /*initButtons();
  initGrid();*/
 
});

document.addEventListener('readystatechange', e => {
  if(document.readyState === "complete"){
  setTimeout(function(){
      initButtons();
  initGrid();
}, 2000);

  } 
   
});

document.addEventListener('shopify-wishlist:updated', (event) => { 
  document.querySelector(selectors.wishlistCount).textContent = event.detail.wishlist.length;
  initGrid();
  toggleWishlistBubbleVisibility();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Product List Loaded', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
 // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ', event.detail.wishlist);
    document.querySelector(selectors.wishlistCount).textContent = event.detail.wishlist.length;
  

});
document.addEventListener('shopify-wishlist:init-buttons-added-button', (event) => {
 // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ', event.detail.wishlist);
    //alert("button intiated from event");
  

   const buttons = document.querySelectorAll(selectors.button) || [];
 buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    //if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
   
  });
});




/*const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`Shopify Wishlist Failed to load content for handle: ${handle}`, err));
};*/

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => {
      if (!res.ok) {
        console.log(res);
        // Check if response indicates that product is not found
        if (res.status === 404 ) {
          // Remove the handle from the wishlist array
          const wishlist = getWishlist();
          const index = wishlist.indexOf(handle);
          if (index > -1) {
            wishlist.splice(index, 1);
            console.log(wishlist)
            setWishlist(wishlist);
          }
        }
        // Throw an error to skip the rest of the promise chain
        throw new Error("Product not found");
      }
      return res.text();
    })
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    })
    .catch((err) => {
      console.error(`Shopify Wishlist Failed to load content for handle: ${handle}`, err);
      return ''; // return a placeholder HTML element or null
    });
};


const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', (event) => {
    
      updateWishlist(productHandle);      
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    
    });
  });
};




/*const setupButtons = (buttons) => {

  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
  
  });
  
  document.body.addEventListener('click', (event) => {   
    console.log(event.target.parentNode);
  
       if (event.target.matches(selectors.button)) {
      const button = event.target;
      const productHandle = button.dataset.productHandle || false;
      if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    }
  });
};*/



const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

/*const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};
*/

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);

  /*const buttonObserver = new MutationObserver(() => {
    initButtons();
  });

  buttons.forEach(button => {
    buttonObserver.observe(button.parentNode, {
      childList: true,
    });
  });*/

 /* const buttonObserver = new MutationObserver(() => {
  if (buttons.length !== document.querySelectorAll('.wishlist').length) {
  let  wbuttons = Array.from(document.querySelectorAll('.wishlist'));
    initButtons();
    console.log("new buttons added");
  }
});

buttonObserver.observe(document.body, {
  childList: true,
  subtree: true,
}); */

};



const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};